import "./Card.css";
import { Link } from "react-router-dom";
import gilbraterImage from "../gilbrater.jpg";

const Card = ({
  id = "profile",
  name = "Nome",
  location = "Accra, Ghana",
  image = gilbraterImage,
  service= "Massage",
}) => {
  return (
    <Link className="card-wrapper" to={`/profile/${id}`}>
      <img className="card-image" src={image?image:null} alt={name} />
      <div className="card-details">
        <h3 className="card-name">{name}</h3>
        <p className="card-location">{service}</p>
        <p className="card-location">{location}</p>
      </div>
    </Link>
  );
};

export default Card;
